// ============================================================
// Sunday Ground Teer - MOCK DATA (frontend only)
// This will later be replaced by real backend/admin data.
// ============================================================

// ---- seeded PRNG so numbers are stable per date ----
function seedFromString(str) {
  let h = 1779033703 ^ str.length;
  for (let i = 0; i < str.length; i++) {
    h = Math.imul(h ^ str.charCodeAt(i), 3432918353);
    h = (h << 13) | (h >>> 19);
  }
  return h >>> 0;
}
function mulberry32(a) {
  return function () {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
function pad2(n) {
  return String(n).padStart(2, "0");
}
function fmtDMY(d) {
  return `${pad2(d.getDate())}-${pad2(d.getMonth() + 1)}-${d.getFullYear()}`;
}
function fmtSlash(d) {
  return `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}/${d.getFullYear()}`;
}

// ---- Generate Previous Results from 01-01-2019 to today ----
function generateResults() {
  const results = [];
  const start = new Date(2019, 0, 1);
  const end = new Date(2026, 7, 9); // 09-08-2026 (matches sample list)
  for (let d = new Date(end); d >= start; d.setDate(d.getDate() - 1)) {
    const key = fmtDMY(d);
    const rng = mulberry32(seedFromString(key));
    const fr = pad2(Math.floor(rng() * 100));
    const sr = pad2(Math.floor(rng() * 100));
    results.push({
      city: "Shillong",
      date: fmtDMY(d),
      dateObj: `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`,
      fr,
      sr,
    });
  }
  return results;
}

export const RESULTS = generateResults();

// ---- Today's Result (the box shown on Home - matches sample photo) ----
export const TODAY_RESULT = {
  date: fmtSlash(new Date(2026, 7, 8)), // 08/08/2026
  city: "SHILLONG",
  frTime: "10.30AM",
  srTime: "11.30AM",
  frNumber: "60",
  srNumber: "51",
};

// ---- Latest previous result mini table (Roboto style) ----
export function getLatestPrevious() {
  const r = RESULTS[0];
  const [y, m, dd] = r.dateObj.split("-");
  return {
    date: `${dd}/${m}/${y}`,
    city: "SHILLONG",
    frTime: "10.30AM",
    srTime: "11.30AM",
    fr: r.fr,
    sr: r.sr,
  };
}

// ============================================================
// AUTO-CHANGING sections (based on previous results + date seed)
// ============================================================
function todaySeed() {
  const now = new Date();
  return mulberry32(
    seedFromString(`${now.getFullYear()}-${now.getMonth()}-${now.getDate()}`)
  );
}

// Analysis Teer -> Daily Guti numbers (2-digit direct picks)
export function getDailyGuti() {
  const rng = todaySeed();
  const set = new Set();
  while (set.size < 8) set.add(pad2(Math.floor(rng() * 100)));
  return [...set];
}

// Predict Target -> House / Ending / Direct predictions
export function getPredictTarget() {
  const rng = todaySeed();
  const house = [];
  const ending = [];
  const direct = [];
  const hs = new Set();
  while (hs.size < 4) hs.add(String(Math.floor(rng() * 10)));
  const es = new Set();
  while (es.size < 4) es.add(String(Math.floor(rng() * 10)));
  const ds = new Set();
  while (ds.size < 6) ds.add(pad2(Math.floor(rng() * 100)));
  hs.forEach((v) => house.push(v));
  es.forEach((v) => ending.push(v));
  ds.forEach((v) => direct.push(v));
  return { house, ending, direct };
}

// ============================================================
// COMMON NUMBER  (shown after clicking Common Number box)
// ============================================================
export function getCommonNumber() {
  const rng = todaySeed();
  const two = () => pad2(Math.floor(rng() * 100));
  const one = () => String(Math.floor(rng() * 10));
  return {
    date: fmtSlash(new Date(2026, 7, 8)),
    fr: { direct: `${two()},${two()}`, house: one(), ending: one() },
    sr: { direct: `${two()},${two()}`, house: one(), ending: one() },
  };
}

// ============================================================
// DREAM NUMBERS  (dream -> lucky numbers)
// ============================================================
export const DREAM_NUMBERS = [
  { dream: "Snake", direct: "23, 32", house: "2", ending: "3" },
  { dream: "Water / River", direct: "07, 70", house: "0", ending: "7" },
  { dream: "Fire", direct: "45, 54", house: "4", ending: "5" },
  { dream: "Money / Gold", direct: "11, 78", house: "1", ending: "8" },
  { dream: "Cow / Buffalo", direct: "39, 93", house: "3", ending: "9" },
  { dream: "Dog", direct: "16, 61", house: "1", ending: "6" },
  { dream: "Elephant", direct: "88, 08", house: "8", ending: "8" },
  { dream: "Death / Funeral", direct: "25, 52", house: "2", ending: "5" },
  { dream: "Marriage", direct: "34, 43", house: "3", ending: "4" },
  { dream: "Baby / Child", direct: "12, 21", house: "1", ending: "2" },
  { dream: "Blood", direct: "58, 85", house: "5", ending: "8" },
  { dream: "Fish", direct: "67, 76", house: "6", ending: "7" },
  { dream: "Flying", direct: "90, 09", house: "9", ending: "0" },
  { dream: "Falling", direct: "31, 13", house: "3", ending: "1" },
  { dream: "House / Building", direct: "44, 04", house: "4", ending: "4" },
  { dream: "Car / Vehicle", direct: "72, 27", house: "7", ending: "2" },
  { dream: "Temple / God", direct: "01, 10", house: "1", ending: "0" },
  { dream: "Tree / Forest", direct: "36, 63", house: "3", ending: "6" },
  { dream: "Rain", direct: "48, 84", house: "4", ending: "8" },
  { dream: "Bird", direct: "59, 95", house: "5", ending: "9" },
  { dream: "Tiger / Lion", direct: "77, 07", house: "7", ending: "7" },
  { dream: "Police", direct: "26, 62", house: "2", ending: "6" },
  { dream: "Doctor / Hospital", direct: "38, 83", house: "3", ending: "8" },
  { dream: "School / Book", direct: "15, 51", house: "1", ending: "5" },
  { dream: "Rice / Food", direct: "20, 02", house: "2", ending: "0" },
  { dream: "Flowers", direct: "69, 96", house: "6", ending: "9" },
  { dream: "Mountain", direct: "33, 03", house: "3", ending: "3" },
  { dream: "Boat", direct: "56, 65", house: "5", ending: "6" },
  { dream: "Milk", direct: "18, 81", house: "1", ending: "8" },
  { dream: "Jewellery", direct: "24, 42", house: "2", ending: "4" },
];

// ============================================================
// COUNTER  (contact info)
// ============================================================
export const CONTACT = {
  email: "Shillongmorningteer4758@gmail.com",
  title: "Contact / Counter",
};

// ============================================================
// TEER CLUB CHART  -> lookup result by date (calendar)
// ============================================================
export function getResultByDate(isoDate) {
  // isoDate: yyyy-mm-dd
  return RESULTS.find((r) => r.dateObj === isoDate) || null;
}

// ============================================================
// BLOG
// ============================================================
export const BLOG_POSTS = [
  {
    id: 1,
    title: "How to Read Sunday Ground Teer Result Correctly",
    date: "05-08-2026",
    excerpt:
      "Understand First Round (F/R) and Second Round (S/R), and how the Direct, House and Ending numbers are formed from the daily result.",
  },
  {
    id: 2,
    title: "What is Common Number in Teer?",
    date: "02-08-2026",
    excerpt:
      "Common numbers are the most probable picks derived from past results and hit-rate analysis. Learn how they help.",
  },
  {
    id: 3,
    title: "Dream Number Meanings - Full Guide",
    date: "28-07-2026",
    excerpt:
      "See what your dreams may mean and the traditional numbers associated with them in the Teer community.",
  },
];

// ---- 9 boxes config (Home grid) ----
export const HOME_BOXES = [
  { key: "common", label: "Common Number", letter: "C", to: "/common-number", theme: "orange" },
  { key: "blog", label: "Blog", letter: "B", to: "/blog", theme: "cream" },
  { key: "dream", label: "Dream Number", letter: "D", to: "/dream-number", theme: "orange" },
  { key: "analysis", label: "Analysis Teer", icon: "chart", to: "/analysis", theme: "teal" },
  { key: "predict", label: "Predict Target", icon: "arrows", to: "/predict-target", theme: "brown" },
  { key: "previous", label: "Previous Result", icon: "target", to: "/previous-result", theme: "teal" },
  { key: "club", label: "Teer Club Chart", icon: "table", to: "/club-chart", theme: "dark" },
  { key: "counter", label: "Counter", icon: "counter", to: "/counter", theme: "cream" },
  { key: "app", label: "Sunday Ground Teer App", icon: "phone", to: "/app-download", theme: "dark" },
];
